<template>
  <div class="page">
    <!-- 团课背景 -->
    <img v-if="backgroundType === 'image' && info.teamBackgroundImage" :src="info.teamBackgroundImage" class="bg" />
    <video v-else-if="backgroundType === 'video'" ref="videoRef" src="@/assets/sp.mp4" class="bg" loop :muted="videoVolume === 0" @loadedmetadata="onVideoLoaded"></video>
    <ScreenAdapter>
      <div class="pageContent">
        <!-- 右侧团课信息 -->
        <div class="left">
          <el-select v-model="defaultStoreSign" placeholder="Select" size="large">
            <el-option v-for="item in storeList" :key="item" :label="item.name" :value="item.sign" />
          </el-select>
          <div class="time">{{ newDate }}</div>
          <div class="btn" @click="$router.push('/ranking')">{{ info.teamName }}</div>
          <div class="code">
            <img :src="localQrUrl" width="100%" />
            <div v-if="!info.coachName">扫码加入团课</div>
            <div v-else>团课教练：{{ info.coachName }}</div>
          </div>
          <div class="level" v-for="(item, idx) in info.intensityData" :key="idx">
            <div :style="`background: ${item.color}`" class="bg" />
            <div style="position: relative; z-index: 1;">
              <img :src="item.icon" />
              <span>{{ item.intensity }}</span>
            </div>
          </div>
          <div class="btnBox">
            <div class="btn" @click="openMusicDialog">配置</div>
            <div class="btn" @click="grid = grid == 6 ? 1 : grid + 1">画面</div>
          </div>
        </div>
        <!-- 左侧列表 -->
        <div class="right" :style="`gap: ${style[grid-1].gap}px;`">
          <div v-for="item, key in localUserList" :key="key" :style="{
            width: `${style[grid-1].width}px`,
            height: `${style[grid-1].height}px`,
            backgroundImage: `url(${require(`@/assets/rate/${boxBgImg[item.background]}.png`)})`
          }">
            <div class="scale" :style="`transform: translate(0, 0) scale(${style[grid-1].scale});transform-origin: top left;`">
              <div class="content">
                <!-- 会员信息 -->
                <div class="time">
                  <div class="avatar">
                    <img :src="item.avatar" height="134px" width="134px" style="border-radius: 100%;" />
                    <label>{{ item.nickname }}</label>
                  </div>
                  <div>
                    <div class="time_left">
                      <div class="title">{{sportType ? '上' : '本'}}周运动</div>
                      <div>
                        <img src="@/assets/rate/count.png" height="42px" />
                        <span>{{ item[typeField[sportType]+'Time'] }}min</span>
                      </div>
                      <div class="progress" style="margin-bottom: 25px;">
                        <div :style="`width: ${item[typeField[sportType]+'TimeProgress']}%`" />
                        <label v-if="item[typeField[sportType]+'TimeProgress'] == 100" style="right: 0;color: #000;">已达标</label>
                        <label v-else :style="`left: ${item[typeField[sportType]+'TimeProgress']}%`">未达标</label>
                      </div>
                      <div>
                        <img src="@/assets/rate/time.png" height="42px" />
                        <span>{{ item[typeField[sportType]+'Count'] }}次</span>
                      </div>
                      <div class="progress">
                        <div :style="`width: ${item[typeField[sportType]+'CountProgress']}%`" />
                        <label v-if="item[typeField[sportType]+'CountProgress'] == 100" style="right: 0;color: #000;">已达标</label>
                        <label v-else :style="`left: ${item[typeField[sportType]+'CountProgress']}%`">未达标</label>
                      </div>
                    </div>
                    <div class="time_right">
                      <div v-if="item.sportBeforeBloodOxygen && item.sportBeforeBloodOxygen !== '0%'" class="blood_oxygen">
                        <img src="@/assets/blood_sugar.png" height="42px" />
                        <span class="value">{{ item.sportBeforeBloodOxygen }}</span>
                      </div>
                      <div>
                        <img src="@/assets/rate/icon-fire.png" height="41px" style="margin-left: 4px;" />
                        <span style="width: 160px;">{{ item.calorie }}kcal</span>
                      </div>
                      <div>
                        <img src="@/assets/rate/icon-time.png" height="42px" />
                        <span>{{ item.time }}</span>
                      </div>
                      <div v-if="item.blood_sugar" @click="charLineHeartRate(item.userSign)">
                        <img :src="require(`@/assets/rate/icon_sugar${item.bloodSugarIsOnline ? '' : '_gery'}.png`)" height="42px" />
                        <p>{{ item.blood_sugar }}</p>
                        <img :src="require(`@/assets/rate/icon_${item.blood_sugar_trend ? item.blood_sugar_trend == 1 ? 'down' : 'up' : 'nochange'}.png`)" width="45px" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 心率 -->
                <div class="realTime">
                  <div class="fatBurn" :style="`background-image: url(${require(`@/assets/rate/${boxBgImg[item.background]}_btn.png`)})`">
                    <img src="@/assets/rate/burning.png" height="30px" />{{ item.fat_burning }}g
                  </div>
                  <div class="rate">
                    <img src="@/assets/rate/heart-circle.png" width="250px" />
                    <div>
                      <img src="@/assets/rate/icon_rate.png" height="30px" />
                      <div>{{ item.heart_rate }}</div>
                      <label>bpm</label>
                    </div>
                  </div>
                  <div class="intensity">
                    <div style="border-right: 2px solid;">
                      <p>{{ item.sportBeforeBloodPressure }}</p>当前血压
                    </div>
                    <div>
                      <p>{{ item.safeSportIntensity }}</p>心率有效范围
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScreenAdapter>
  </div>
  <el-dialog title="动态血糖+运动强度曲线图" v-model="dialogVisible" width="896px" header-class="headerDialog">
    <div ref="chartRef" style="height: 500px;margin-top: 70px;padding-bottom: 15px;" />
  </el-dialog>
  <!-- 配置弹框 -->
  <el-dialog title="配置" v-model="musicDialogVisible" width="600px" :close-on-click-modal="false" class="music-dialog">
    <el-tabs v-model="activeTab" class="config-tabs">
      <!-- 音乐播放tab -->
      <el-tab-pane label="音乐播放" name="music">
        <BackgroundMusic ref="backgroundMusic" :tracks="musicTracks" />
      </el-tab-pane>
      
      <!-- 背景设置tab -->
      <el-tab-pane label="背景设置" name="background">
        <div class="background-settings">
          <div class="setting-section">
            <div class="setting-title">背景类型</div>
            <div class="background-type-group">
              <div 
                class="type-radio" 
                :class="{ 'is-checked': backgroundType === 'image' }"
                @click="setBackgroundType('image')"
              >
                <div class="type-option">
                  <div class="type-icon">🖼️</div>
                  <div class="type-label">图片</div>
                </div>
              </div>
              <div 
                class="type-radio" 
                :class="{ 'is-checked': backgroundType === 'video' }"
                @click="setBackgroundType('video')"
              >
                <div class="type-option">
                  <div class="type-icon">🎬</div>
                  <div class="type-label">视频</div>
                </div>
              </div>
            </div>
          </div>
          
          <div v-if="backgroundType === 'video'" class="video-settings">
            <div class="setting-title">视频设置</div>
            <div class="video-info">使用固定视频背景</div>
            <div class="video-controls">
              <div class="play-pause-btn" @click="toggleVideoPlayback">
                <svg v-if="!videoStarted" viewBox="0 0 24 24" width="20" height="20" fill="#333">
                  <path d="M8 5v14l11-7z"/>
                </svg>
                <svg v-else viewBox="0 0 24 24" width="20" height="20" fill="#333">
                  <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                </svg>
              </div>
              <div class="volume-control">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="#999" class="volume-icon" @click="toggleVideoMute">
                  <path v-if="videoVolume > 0" d="M3 9v6h4l5 5V4L7 9H3z"/>
                  <path v-else d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                </svg>
                <input
                  type="range"
                  class="volume-slider"
                  min="0"
                  max="100"
                  :value="videoVolume"
                  @input="setVideoVolume($event.target.value)"
                />
                <span class="volume-text">{{ videoVolume }}%</span>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import ScreenAdapter from '../../components/ScreenAdapter';
import { websocketUrl } from '../utils/env.js';
import { getInfo, getStoreList, getChartDate, getBackgroundMusicList } from '@/api';
import { ElSelect, ElOption, ElLoading, ElDialog, ElTabs, ElTabPane } from 'element-plus';
import BackgroundMusic from './BackgroundMusic.vue';
import * as echarts from "echarts";
let loadingInstance;
export default {
  name: "HeartRateMonitor",
  components: { ElSelect, ElOption, ScreenAdapter, ElDialog, ElTabs, ElTabPane, BackgroundMusic },
  data() {
    return {
      height: window.innerHeight,
      localQrUrl: '',
      newDate: '',
      info: {},
      ws: null,
      isConnected: false,
      heartbeatTimer: null,
      reconnectTimer: null,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      grid: 1,
      localUserList: [],
      style: [
        {width: 1594, height: 982, gap: 0, scale: 2},
        {width: 782, height: 491, gap: 30, scale: 1},
        {width: 518, height: 326, gap: 20, scale: 0.66},
        {width: 383.5, height: 240, gap: 20, scale: 0.489},
        {width: 310.8, height: 196, gap: 10, scale: 0.399},
        {width: 257, height: 161, gap: 10, scale: 0.329},
      ],
      listLength: 0,
      boxBgImg: {
        '#3f96f7': 'low',
        '#8dd146': 'm_low',
        '#e8d103': 'medium',
        '#F1933B': 'm_high',
        '#E6562F': 'm_high+',
        '#A32181': 'high'
      },
      storeList: [],
      defaultStoreSign: null,
      dialogVisible: false,
      musicDialogVisible: false,
      sportType: 0,
      typeField: ['weekSport', 'lastWeekSport'],
      refreshTimer: null,
      visibilityHandler: null,
      /** 背景音乐列表 - 从服务器接口获取 */
      musicTracks: [],
      /** 背景类型: 'image' 或 'video' */
      backgroundType: localStorage.getItem('backgroundType') || 'image',
      /** 视频音量 (0-100) */
      videoVolume: parseInt(localStorage.getItem('videoVolume')) || 50,
      /** 视频保存进度定时器 */
      videoSaveTimer: null,
      /** 视频是否已开始播放 */
      videoStarted: false,
      /** 当前活动的配置tab */
      activeTab: 'music'
    }
  },
  created() {
    this.loadMusicTracks();
    this.getStore();
    this.updateTime();
    setInterval(this.updateTime, 60000);
    this.initWebSocket(); // 获取上课人员心率数据
    // 10秒切换上周和本周运动数据
    setInterval(() => {
      this.sportType = this.sportType ? 0 : 1
    }, 10000)
    // 30秒刷新一次心率监控数据，仅在页面可见时刷新
    this.visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        this.startRefreshTimer();
        // 立即刷新一次
        if (this.defaultStoreSign) {
          this.getBase(this.defaultStoreSign, false);
        }
      } else {
        this.stopRefreshTimer();
      }
    };
    document.addEventListener('visibilitychange', this.visibilityHandler);
    // 初始启动定时器
    if (document.visibilityState === 'visible') {
      this.startRefreshTimer();
    }
    // 如果背景类型是视频，不尝试自动播放，等待用户交互
    // 视频将显示播放按钮，用户点击后开始播放
  },
  mounted() {
    // 视频将显示播放按钮，用户点击后开始播放
    // 这里不需要自动播放尝试
  },
  watch: {
    listLength(len) {
      this.grid = len == 1 ? 1 : len <= 4 ? 2 : len <= 9 ? 3 : len <= 16 ? 4 : len <= 25 ? 5 : 6;
    },
    defaultStoreSign(val) {
      localStorage.setItem('defaultStoreSign', val)
      this.getBase(val)
    },
    backgroundType(val) {
      localStorage.setItem('backgroundType', val)
      // 如果选择视频背景，停止音乐播放并保存进度
      if (val === 'video' && this.$refs.backgroundMusic) {
        this.$refs.backgroundMusic.pause()
        // 延迟启动进度保存，等待视频加载
        setTimeout(() => {
          this.startVideoProgressSave();
        }, 1000);
      } else if (val === 'image') {
        // 切换到图片时，保存视频进度并停止定时保存
        this.saveVideoProgress();
        this.stopVideoProgressSave();
      }
    }
  },
  beforeUnmount() {
    this.closeWebSocket();
    this.stopRefreshTimer();
    this.stopVideoProgressSave();
    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler);
    }
  },
  methods: {
    /** 打开配置弹框（血糖曲线图） */
    showDialog() {
      this.dialogVisible = true;
    },
    /** 打开背景音乐配置弹框 */
    openMusicDialog() {
      this.musicDialogVisible = true;
    },
    /** 设置背景类型 */
    setBackgroundType(type) {
      console.log('Setting background type to:', type);
      this.backgroundType = type;
    },
    /** 视频加载完成 */
    onVideoLoaded() {
      // 设置音量
      this.setVideoVolume(this.videoVolume);
      // 恢复播放进度
      this.restoreVideoProgress();
      // 不再尝试自动播放，等待用户交互
    },
    /** 尝试播放视频 */
    tryPlayVideo() {
      if (this.$refs.videoRef && this.backgroundType === 'video') {
        // 尝试播放
        const playPromise = this.$refs.videoRef.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {
            console.log('视频播放成功');
            this.videoStarted = true;
          }).catch(error => {
            console.warn('视频自动播放被阻止:', error);
            this.videoStarted = false;
          });
        }
      }
    },
    /** 用户交互后开始播放视频 */
    startVideoPlayback() {
      if (this.$refs.videoRef) {
        this.$refs.videoRef.play().then(() => {
          this.videoStarted = true;
          // 启动进度保存
          this.startVideoProgressSave();
        }).catch(error => {
          console.error('视频播放失败:', error);
        });
      }
    },
    /** 切换视频播放/暂停 */
    toggleVideoPlayback() {
      if (this.$refs.videoRef) {
        if (this.videoStarted) {
          // 暂停
          this.$refs.videoRef.pause();
          this.videoStarted = false;
          this.stopVideoProgressSave();
        } else {
          // 播放
          this.startVideoPlayback();
        }
      }
    },
    /** 保存视频播放进度 */
    saveVideoProgress() {
      if (this.$refs.videoRef && this.backgroundType === 'video') {
        const currentTime = this.$refs.videoRef.currentTime;
        const duration = this.$refs.videoRef.duration;
        if (currentTime && duration && !isNaN(currentTime) && !isNaN(duration)) {
          localStorage.setItem('videoCurrentTime', currentTime.toString());
          localStorage.setItem('videoDuration', duration.toString());
        }
      }
    },
    /** 恢复视频播放进度 */
    restoreVideoProgress() {
      if (this.$refs.videoRef && this.backgroundType === 'video') {
        const savedTime = localStorage.getItem('videoCurrentTime');
        if (savedTime) {
          const time = parseFloat(savedTime);
          if (!isNaN(time)) {
            this.$refs.videoRef.currentTime = time;
          }
        }
        // 启动定时保存进度
        this.startVideoProgressSave();
      }
    },
    /** 启动视频进度定时保存 */
    startVideoProgressSave() {
      // 清除之前的定时器
      if (this.videoSaveTimer) {
        clearInterval(this.videoSaveTimer);
      }
      // 每5秒保存一次进度
      this.videoSaveTimer = setInterval(() => {
        this.saveVideoProgress();
      }, 5000);
    },
    /** 停止视频进度定时保存 */
    stopVideoProgressSave() {
      if (this.videoSaveTimer) {
        clearInterval(this.videoSaveTimer);
        this.videoSaveTimer = null;
      }
    },
    /** 设置视频音量 */
    setVideoVolume(value) {
      const volume = parseInt(value, 10);
      if (isNaN(volume)) {
        this.videoVolume = 50;
      } else {
        this.videoVolume = Math.min(100, Math.max(0, volume));
      }
      if (this.$refs.videoRef) {
        this.$refs.videoRef.volume = this.videoVolume / 100;
        // 当音量大于0时取消静音，等于0时静音
        this.$refs.videoRef.muted = (this.videoVolume === 0);
        localStorage.setItem('videoVolume', this.videoVolume);
      }
    },
    /** 视频静音切换 */
    toggleVideoMute() {
      if (this.videoVolume > 0) {
        this._prevVideoVolume = this.videoVolume;
        this.setVideoVolume(0);
      } else {
        this.setVideoVolume(this._prevVideoVolume || 50);
      }
    },
    /** 加载背景音乐列表 */
    async loadMusicTracks() {
      try {
        const res = await getBackgroundMusicList();
        // utils/request.js 解包后 res 就是 data 数组
        if (Array.isArray(res)) {
          this.musicTracks = res.map(item => ({
            name: item.name,
            src: item.src
          }));
        }
      } catch (e) {
        console.warn('获取背景音乐列表失败:', e);
        // 接口失败时使用默认音乐
        this.musicTracks = [{ name: '背景音乐', src: '/music/1.mp3' }];
      }
    },
    // 获取门店列表
    async getStore() {
      const location = JSON.parse(localStorage.getItem('geolocation'))
      getStoreList(location).then(res => {
        this.storeList = res
        const defaultSign = localStorage.getItem('defaultStoreSign')
        let sign = ''
        if(defaultSign && defaultSign != 'null' && defaultSign != 'undefined') {
          const item = res.find(v => v.sign == defaultSign)
          if(item) {
            sign = item.sign
          }
        }
        this.defaultStoreSign = sign || res[0].sign || ''
      })
    },
    // 获取门店团课信息
    getBase(storeSign, showLoading = true) {
      if (showLoading) {
        loadingInstance = ElLoading.service({ fullscreen: true })
      }
      getInfo({ storeSign }).then(res => {
        const { qrCode } = res
        // 处理二维码数据
        if (qrCode) {
          this.localQrUrl = qrCode.startsWith("data:image") ? qrCode : `data:image/png;base64,${qrCode}`
        }
        this.info = res
      }).catch(() => {
        // 接口失败时清空旧数据，避免展示上一次门店的团课信息
        this.info = {}
        this.localUserList = []
      }).finally(() => {
        if (showLoading && loadingInstance) {
          setTimeout(() => {
            loadingInstance.close()
          }, 200)
        }
      })
    },
    // WebSocket连接
    initWebSocket() {
      try {
        this.ws = new WebSocket(websocketUrl);
        this.ws.onopen = () => {
          console.log("WebSocket连接已建立");
          this.isConnected = true;
          this.reconnectAttempts = 0;
          this.startHeartbeat();
        };

        this.ws.onmessage = (event) => {
          const data = JSON.parse(event.data);
          console.log("收到WebSocket消息:", data);
          if (data.event === "pong") {
            // 处理心跳响应
            console.log("收到心跳响应");
          } else if (data.event === "heartRateMianMonitor") {
            // 处理心率数据
            this.listLength = data.data.length;
            this.localUserList = data.data
          }
        };

        this.ws.onclose = () => {
          console.log("WebSocket连接已关闭");
          this.isConnected = false;
          this.stopHeartbeat();
          this.reconnect();
        };

        this.ws.onerror = (error) => {
          console.error("WebSocket错误:", error);
          this.isConnected = false;
        };
      } catch (error) {
        console.error("WebSocket初始化错误:", error);
        this.reconnect();
      }
    },
    startHeartbeat() {
      this.heartbeatTimer = setInterval(() => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          const heartbeat = {
            data: {},
            event: "ping",
            sign: this.info.teamSign, // 使用teamSign作为心跳包的sign参数
          };
          this.ws.send(JSON.stringify(heartbeat));
        }
      }, 1000); // 每1秒发送一次心跳
    },
    // 关闭连接
    closeWebSocket() {
      this.stopHeartbeat();
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
      }
      if (this.ws) {
        this.ws.close();
      }
    },
    // 关闭心跳
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },
    // 重新连接
    reconnect() {
      if (this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts++;
        console.log(
          `尝试重新连接 (${this.reconnectAttempts}/${this.maxReconnectAttempts})`
        );

        this.reconnectTimer = setTimeout(() => {
          this.initWebSocket();
        }, 5000); // 5秒后重试
      } else {
        console.error("达到最大重连次数，停止重连");
      }
    },
    // 获取实时时间
    updateTime() {
      const now = new Date();
      this.newDate = `${now.getHours().toString().padStart(2, "0")}:${now
      .getMinutes() 
      .toString()
      .padStart(2, "0")}`;
    },
    // 动态血糖曲线
    async charLineHeartRate(userSign) {
      const result = await getChartDate({ userSign, teamSign: this.info.teamSign })
      this.dialogVisible = true
      this.$nextTick(() => {
        const myChart = echarts.init(this.$refs.chartRef), markLine = [];
        // 警戒线
        [3.9, 11.1, 7.8, 8.6].forEach(v => {
          const color = (v == 7.8 || v == 8.6) ? '#a0a0a0' : '#ff6b6b'
          const obj = {
            symbol: false,
            yAxis: v,
            emphasis: {
              lineStyle: { width: 1.5 }
            },
            lineStyle: { width: 1.5 },
            itemStyle: { color },
            label: {
              formatter(value) {
                let str = value.value
                if(v == 3.9 || v == 11.1) {
                  str = `${v == 3.9 ? '低' : '高'}血糖警戒值${value.value}mmol/L`
                }
                return str
              },
              show: true,
              position: 'insideStartTop',
              fontFamily: 'PingFang SC',
              fontSize: 16,
              color
            }
          }
          markLine.push(obj)
        })
        // y坐标轴
        const yAxis = [];
        ['mmol/L', 'bpm'].forEach(v => {
          const obj = {
            type: 'value',
            nameGap: 25,
            name: `(${v})`,
            alignTicks: true,
            nameTextStyle: {
              fontSize: 15,
              color: '#666',
              align: v == 'bpm' && 'left'
            },
            axisLine: {
              show: true, 
              lineStyle: {
                color: '#f2f2f2'
              }
            },
            axisLabel: {
              fontSize: 15,
              margin: 15
            },
            splitLine: {
              show: v == 'mmol/L',
              lineStyle: {
                color: '#f2f2f2'
              }
            },
            max: 15
          }
          if(v == 'bpm') {
            obj.max = 180,
            obj.min = 30
          }
          yAxis.push(obj)
        })
        // 心率图颜色区分
        const pieces = []
        result.strength.map((v, k) => {
          const obj = {gt: v.leftRange, lte: v.rangeRange, color: v.color}
          v.leftRange ==  v.rangeRange && delete(obj[k == 0 ? 'gt' : 'lte'])
          pieces.push(obj)
        })
        // 图表基础配置
        const min = result.startTime * 1000, max = result.endTime * 1000;
        const option = {
          grid: { 
            containLabel: true,
            left: 20,
            right: 20,
            top: 40,
            bottom: 0,
            heigth: '100%'
          },
          tooltip: { trigger: 'axis' },
          xAxis: [{
            type: 'time',
            min,
            max,
            boundaryGap: false,
            axisLine: {show: false},
            axisTick: {show: false},
            alignTicks: true,
            axisLabel: {
              fontSize: 15,
              margin: 20,
              showMaxLabel: true,
              showMinLabel: true,
              formatter(value) {
                return echarts.format.formatTime('hh:mm', value);
              }
            }
          }, {
            type: 'time',
            min: result.startTime * 1000 - 24 * 60 * 60 * 1000,
            max: result.endTime * 1000 - 24 * 60 * 60 * 1000,
            alignTicks: true,
            boundaryGap: false,
            axisLine: {show: false},
            axisLabel: {
              show: false,
              showMaxLabel: true,
              showMinLabel: true
            },
            axisTick: {show: false}
          }],
          yAxis,
          visualMap: [{
            seriesIndex: 0,
            show: false,
            pieces: [
              {gt: 11.1, color: '#ff6b6b'}, 
              {gt: 3.9, lte: 11.1, color: '#333742'},
              {lt: 3.9, color: '#ff6b6b'}
            ]
          }, {
            seriesIndex: 2,
            show: false,
            pieces
          }],
          series: [{
            type: 'line',
            name: 'mmol/L',
            yAxisIndex: 0,
            xAxisIndex: 0,
            zlevel: 2,
            smooth: true,
            showSymbol: false,
            data: result.todayglucose,
            lineStyle: { width: 3 },
            markLine: { data: markLine }
          }, {
            type: 'line',
            emphasis: {
              lineStyle: {
                color: '#dedfe1'
              }
            },
            name: 'mmol/L',
            zlevel: 1,
            yAxisIndex: 0,
            smooth: true,
            showSymbol: false,
            data: result.yesterdayglucose,
            xAxisIndex: 1,
            itemStyle: { color: '#dedfe1' }
          }, {
            type: 'bar',
            barWidth: '100%',
            zlevel: 0,
            yAxisIndex: 1,
            xAxisIndex: 0,
            name: 'bpm',
            smooth: true,
            showSymbol: false,
            data: result.heartRate,
            areaStyle: {}
          }
        ]}
        option && myChart.setOption(option)
      })
    },
    startRefreshTimer() {
      this.stopRefreshTimer();
      this.refreshTimer = setInterval(() => {
        if (this.defaultStoreSign) {
          this.getBase(this.defaultStoreSign, false)
        }
      }, 30000)
    },
    stopRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
:deep(.el-select--large .el-select__wrapper) {
  line-height: 38px;
  font-size: 17px;
  min-height: 54px;
  font-weight: bold;
  border-radius: 10px;
}
.left {
  text-align: center;
  width: 236px;
  .level {
    height: 62px;
    line-height: 62px;
    font-size: 24px;
    margin-bottom: 10px;
    padding-left: 29px;
    text-align: left;
    position: relative;
    .bg {
      height: 100%;
      width: 100%;
      left: 0;
      border-radius: 10px;
      position: absolute;
      opacity: .7;
      z-index: 0;
    }
    img {
      margin-right: 13px;
      height: 26px;
      vertical-align: middle;
    }
  }
  .time {
    font-size: 36px;
    margin: 29px 0;
  }
  .btn {
    height: 53px;
    line-height: 53px;
    font-size: 24px;
    border-radius: 10px;
    cursor: pointer;
    background: linear-gradient(90deg, #59B2FF 0%, #344199 100%);
  }
  .code {
    padding: 10px;
    background: #fff;
    border-radius: 10px;
    font-size: 18px;
    color: #000;
    margin: 20px 0;
  }
  .btnBox {
    display: flex;
    gap: 10px;
    padding-top: 10px;
    div {
      width: 50%;
      height: 63px;
      line-height: 63px;
    }
  }
}
.page {
  background: rgba(18, 17, 17, 0.3);
  .bg {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: -1;
    left: 0;
    top: 0;
  }
  video.bg {
    object-fit: cover;
  }
}
.pageContent {
  width: 100%;
  height: 100%;
  padding: 30px;
  font-family: 'SimHei', '黑体', sans-serif;
  display: flex;
  gap: 30px;
  color: #fff;
  align-items: flex-start;
}
.right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  > div {
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .bg {
    border-radius: 9.44px;
    z-index: 0;
    position: absolute;
    opacity: .7;
  }
  .scale {
    padding: 38px 45px; // 44px 108px 33px 76px
    position: relative;
    width: 100%;
    height: 100%;
    width: 782px;
    height: 491px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 2;
  }
}
.time {
  > div, &_right > div, &_left > div:not(.title) {
    display: flex;
    align-items: center;
  }
  &_right {
    display: flex;
    flex-direction: column;
    gap: 28px;
  }
  &_left {
    border: 1px solid #fff;
    margin-right: 40px;
    padding: 20px 15px;
    border-radius: 20px;
    width: 196px;
  }
  .progress {
    margin-top: 10px;
    border: 2px solid;
    position: relative;
    label {
      position: absolute;
      border: 1px solid #000;
      font-size: 12px;
      display: inline-block;
      width: 44px;
      text-align: center;
      background: #fff;
      border-radius: 10px;
      color: #f00;
      padding: 4px 0;
    }
    div {
      height: 10px;
      background: #5f99d6;
    }
  }
  .title {
    text-align: center;
    font-size: 26px;
    margin-bottom: 18px;
  }
  .avatar {
    gap: 20px;
    margin: 5px 0 30px 0;
  }
  label {
    display: block;
    font-size: 30px;
  }
  span, p {
    font-size: 34px;
    padding-left: 20px;
  }
  p {
    padding-right: 15px;
    text-align: left;
  }
}
.intensity, .fatBurn {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: auto;
}
.fatBurn {
  height: 55px;
  font-size: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 150px;
}
.intensity {
  text-align: center;
  font-weight: bold;
  letter-spacing: 1px;
  background-image: linear-gradient(to right,#96d21766,rgba(237,124,18,.4),#ed401366);
  border: 2px solid;
  border-radius: 10px;
  display: flex;
  div {
    padding: 8px;
  }
  p {
    font-size: 27px;
    line-height: 1;
  }
  width: fit-content;
}
.rate {
  position: relative;
  font-size: 0;
  margin: 25px 0;
  > div {
    position: absolute;
    width: 100%;
    top: 20%;
    text-align: center;
    font-size: 8px;
    line-height: 1;
    div {
      font-size: 85px;
      margin: 6px 0 7px 0;
    }
    label {
      font-size: 24px;
    }
  }
}

/* 配置弹框样式 */
.config-tabs {
  .el-tabs__header {
    margin-bottom: 20px;
  }
  
  .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #eee;
  }
  
  .el-tabs__item {
    font-size: 16px;
    font-weight: 500;
    color: #666;
    
    &.is-active {
      color: #FE5E10;
      font-weight: 600;
    }
  }
}

.background-settings {
  padding: 10px 0;
}

.setting-section {
  margin-bottom: 24px;
}

.setting-title {
  font-weight: bold;
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
}

.background-type-group {
  display: flex;
  gap: 20px;
}



.type-radio {
  cursor: pointer;
  transition: all 0.3s ease;
}

.type-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-width: 70px;
  
  &:hover {
    border-color: #FE5E10;
    background: rgba(254, 94, 16, 0.02);
  }
}

.type-radio.is-checked .type-option {
  border-color: #FE5E10;
  border-width: 2px;
  background: rgba(254, 94, 16, 0.05);
}

.type-icon {
  font-size: 24px;
  line-height: 1;
}

.type-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.video-settings {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.video-info {
  color: #666;
  font-size: 13px;
  margin-bottom: 16px;
}

.video-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.play-pause-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.play-pause-btn:hover {
  background: #e0e0e0;
  transform: scale(1.05);
}

/* 视频音量控制 - 参考BackgroundMusic组件样式 */
.volume-control {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8f8f8;
  padding: 12px 16px;
  border-radius: 8px;
}

.volume-icon {
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.7;
  
  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
}

.volume-slider {
  flex: 1;
  min-width: 120px;
  -webkit-appearance: none;
  appearance: none;
  height: 6px;
  border-radius: 3px;
  background: #e8e8e8;
  outline: none;
  transition: all 0.3s ease;
  
  &:hover {
    height: 7px;
  }
  
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #FE5E10;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 1px 4px rgba(254, 94, 16, 0.3);
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.2);
      box-shadow: 0 2px 8px rgba(254, 94, 16, 0.4);
    }
  }
  
  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #FE5E10;
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 1px 4px rgba(254, 94, 16, 0.3);
    transition: all 0.3s ease;
  }
}

.volume-text {
  font-size: 13px;
  color: #666;
  min-width: 40px;
  text-align: right;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}
</style>
<style lang="scss">
.headerDialog {
  background: linear-gradient(90deg, #59B2FF 0%, #344199 100%);
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 16px 24px;
  border-radius: 5px 5px 0 0;
  .el-dialog__title, .el-dialog__close {
    color: #fff;
    font-weight: bold;
  }
}

/* 背景音乐弹框美化 */
.music-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 20px rgba(254, 94, 16, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  .el-dialog__header {
    background: linear-gradient(135deg, #FE5E10 0%, #ff8a50 50%, #ffab76 100%);
    padding: 18px 24px;
    padding-right: 56px;
    margin: 0;
    border-bottom: none;
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      top: -30px;
      right: -30px;
      width: 100px;
      height: 100px;
      background: rgba(255, 255, 255, 0.08);
      border-radius: 50%;
    }
    &::after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 40px;
      width: 60px;
      height: 60px;
      background: rgba(255, 255, 255, 0.06);
      border-radius: 50%;
    }
  }
  .el-dialog__title {
    color: #fff !important;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.5px;
    position: relative;
    z-index: 1;
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    background: rgba(255, 255, 255, 0.25);
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
    &:hover {
      background: rgba(255, 255, 255, 0.45);
      border-color: rgba(255, 255, 255, 0.8);
      transform: translateY(-50%) scale(1.1);
    }
    .el-dialog__close {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
    }
  }
  .el-dialog__body {
    padding: 0;
    background: #fafafa;
  }
}
</style>
